export const notification = (state) => {
  return state.notification;
};

export const notification_stream = (state) => {
  return state.notification_stream;
};
